import { render, staticRenderFns } from "./FactEducationPlan.vue?vue&type=template&id=64451e63&"
import script from "./FactEducationPlan.vue?vue&type=script&lang=js&"
export * from "./FactEducationPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports